module.exports = __webpack_public_path__ + "img/jgry.96d4213d.jpg";